import React, { useMemo } from 'react';
import styled from 'styled-components';
import Caption from '@joinforma/ui/components/Caption';
import Title2 from '@joinforma/ui/components/Title2';
import HEART_ICON from 'assets/images/heart.png';
import { ReactComponent as FormaLogoSvg } from 'assets/images/forma-logo-dark-text.svg';
import dayjs from 'utils/date-helper';

const Container = styled.footer<{ isHomepageV2: boolean }>`
  background-color: ${({
    theme: {
      colors: {
        background: { primary },
        brand: { secondary },
      },
    },
    isHomepageV2,
  }) => (isHomepageV2 ? secondary : primary)};
  padding: 60px 20px 20px;
  text-align: center;
`;

const Description = styled(Caption)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeartIcon = styled.img`
  width: 20px;
  object-fit: contain;
`;

const MiddleDot = styled(Title2)`
  display: inline-block;
  padding: 0 3px;
`;

const FormaLogo = styled(FormaLogoSvg)`
  height: 16px;
  margin-left: 6px;
  width: 62px;
`;

const Footer = ({ showCompanyPrivacyPolicy = false, isHomepageV2 = false }) => {
  const Tagline = useMemo(
    () =>
      isHomepageV2 ? (
        <>
          {'Crafted with love by '}
          <FormaLogo />
        </>
      ) : (
        <>
          {'Made with '}
          <HeartIcon src={HEART_ICON} />
          {' by Forma, Inc. ©'}
          {dayjs().year()}
        </>
      ),
    [isHomepageV2]
  );
  return (
    <Container isHomepageV2={isHomepageV2}>
      <Description>
        {Tagline}
        {showCompanyPrivacyPolicy ? (
          <>
            <MiddleDot>&middot;</MiddleDot>
            <a
              href="https://aka.ms/dpn"
              target="_blank"
              rel="noopener noreferrer"
            >
              {'Microsoft Data Privacy Notice '}
            </a>
          </>
        ) : (
          <>
            <MiddleDot>&middot;</MiddleDot>
            <a
              href="https://www.joinforma.com/legal/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              {' Privacy Policy '}
            </a>
          </>
        )}
      </Description>
    </Container>
  );
};

export default Footer;
